import { render, staticRenderFns } from "./NewsNew.vue?vue&type=template&id=4a79179e"
import script from "./NewsNew.vue?vue&type=script&lang=js"
export * from "./NewsNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports